var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-message--emoji"},[(_vm.message.createTime)?_c('p',{staticClass:"sc-message-date"},[_vm._v(" "+_vm._s(_vm.message.createTime)+" ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.message.content)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }